module.exports = __webpack_public_path__ + "static/media/pejibaye.2139f6a0.jpeg";